/**
 * Where the reading guides collapse behind a help icon instead of standing open.
 *
 * `FieldGuide` is deliberately always visible on most screens: a definition a
 * reader has to open is a definition they read once, and the figures there look
 * self-explanatory and are not. CADE is the exception by decision: its subscribers
 * are lawyers who read the screen for the answer, and a guide under every panel
 * read as noise and buried it (R11 of the product review). The guides are not
 * removed -- every one is behind a help icon in place, and all of them are
 * collected, open, on `/cade/method`.
 *
 * Widen the list to move another agency to the same presentation.
 */
export const COLLAPSED_GUIDE_PREFIXES: readonly string[] = ['/cade'];

/** The method page shows every guide open, so it is never collapsed. */
const ALWAYS_OPEN: readonly string[] = ['/cade/method'];

/**
 * Whether guides on the current page render as a help icon.
 *
 * Read from `window.location` rather than the router so the shared components
 * need no router context (their unit tests mount them bare, where this is `/`
 * and nothing collapses). A page mounts after the history entry changes, so the
 * value is current whenever a guide renders.
 */
export function guidesCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname;
  if (ALWAYS_OPEN.includes(path)) return false;
  return COLLAPSED_GUIDE_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
